/* LYVET | オクトーン — caixa de compra e efeitos das seções lv-* */
(function () {
  'use strict';
  if (window.__lvInit) return; window.__lvInit = true;

  var yen = function (cents) { return '¥' + Math.round(cents / 100).toLocaleString('ja-JP'); };
  var $ = function (r, s) { return r.querySelector(s); };
  var $$ = function (r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); };

  /* ---------- Galeria ---------- */
  function initGallery(root) {
    var main = $(root, '[data-lv-gal-main]'); if (!main) return;
    var slides = $$(main, '.lv-gal__slide');
    var count = $(root, '[data-lv-gal-count]');
    var thumbs = $$(root, '[data-lv-gal-thumbs] .lv-gal__thumb');
    var idx = 0;
    function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); main.scrollTo({ left: slides[i].offsetLeft - main.offsetLeft, behavior: 'smooth' }); }
    function setActive(i) {
      if (i === idx) return; idx = i;
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      var t = thumbs[i]; if (t && t.parentNode) { var p = t.parentNode; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); }
    }
    var tmr; main.addEventListener('scroll', function () { clearTimeout(tmr); tmr = setTimeout(function () { setActive(Math.round(main.scrollLeft / main.clientWidth)); }, 60); }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.i)); }); });
    var prev = $(root, '[data-lv-gal-prev]'), next = $(root, '[data-lv-gal-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    main.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(idx + 1); if (e.key === 'ArrowLeft') go(idx - 1); });
  }

  /* ---------- Prazo de entrega (JST, pula sáb/dom) ---------- */
  var WD = ['日', '月', '火', '水', '木', '金', '土'];
  function jstNow() { var d = new Date(); return new Date(d.getTime() + d.getTimezoneOffset() * 60000 + 9 * 3600000); }
  function isBiz(d) { var w = d.getDay(); return w !== 0 && w !== 6; }
  function addBiz(d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setDate(x.getDate() + 1); if (isBiz(x)) n--; } return x; }
  function fmt(d) { return (d.getMonth() + 1) + '月' + d.getDate() + '日（' + WD[d.getDay()] + '）'; }
  function initDelivery(root) {
    var box = $(root, '[data-lv-ship]'); if (!box) return;
    var cutoff = Number(root.dataset.cutoff || 14), dmin = Number(root.dataset.dmin || 3), dmax = Number(root.dataset.dmax || 7);
    var from = $(box, '[data-lv-dfrom]'), to = $(box, '[data-lv-dto]'), cdWrap = $(box, '[data-lv-cd-wrap]'), cd = $(box, '[data-lv-cd]');
    function tick() {
      var now = jstNow();
      var base = new Date(now.getTime()); base.setHours(0, 0, 0, 0);
      var beforeCut = isBiz(now) && now.getHours() < cutoff;
      if (!beforeCut) { base = addBiz(base, 1); }
      if (from) from.textContent = fmt(addBiz(base, dmin));
      if (to) to.textContent = fmt(addBiz(base, dmax));
      if (cdWrap) {
        if (beforeCut && cd) {
          var end = new Date(now.getTime()); end.setHours(cutoff, 0, 0, 0);
          var mins = Math.max(0, Math.floor((end - now) / 60000));
          cd.textContent = (mins >= 60 ? Math.floor(mins / 60) + '時間' : '') + (mins % 60) + '分';
          cdWrap.hidden = false;
        } else { cdWrap.hidden = true; }
      }
    }
    tick(); setInterval(tick, 30000);
  }

  /* ---------- Carrinho lateral do tema ---------- */
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() {
    var d = drawer();
    try { if (d && typeof d.getSectionsToRender === 'function') return d.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    return ['cart-drawer', 'cart-icon-bubble'];
  }
  function openCart(json) {
    var d = drawer();
    if (d && json && json.sections && typeof d.renderContents === 'function') {
      try {
        d.classList.remove('is-empty');
        d.renderContents(json);
        if (typeof d.open === 'function' && !d.classList.contains('active')) { setTimeout(function () { if (!d.classList.contains('active')) d.open(); }, 350); }
        return;
      } catch (e) { /* cai no fallback */ }
    }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }
  function notify(json) {
    try { document.dispatchEvent(new CustomEvent('lv:cart-added', { detail: json })); } catch (e) {}
    try { if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lv-buybox', cartData: json }); } catch (e) {}
  }

  /* ---------- Caixa de compra ---------- */
  function initBuybox(root) {
    var variants = []; try { variants = JSON.parse($(root, '[data-lv-variants]').textContent); } catch (e) {}
    var vmap = {}; variants.forEach(function (v) { vmap[v.id] = v; });
    var baseVar = Number(root.dataset.variant);
    var opts = $$(root, '[data-lv-opt]');
    var btn = $(root, '[data-lv-atc]'), btnTotal = $(root, '[data-lv-btn-total]'), err = $(root, '[data-lv-err]');
    var bumps = $$(root, '[data-lv-bump]');

    function selected() { return opts.filter(function (o) { return o.classList.contains('is-selected'); })[0] || opts[0]; }
    function unitsOf(o) {
      var qty = Number(o.dataset.qty) || 1;
      var sels = $$(o, '[data-lv-var]');
      var ids = []; for (var i = 0; i < qty; i++) { ids.push(sels[i] ? Number(sels[i].value) : baseVar); }
      return ids;
    }
    function priceOf(o) {
      var pct = Number(o.dataset.pct) || 0;
      var reg = unitsOf(o).reduce(function (s, id) { return s + ((vmap[id] && vmap[id].p) || Number(root.dataset.unit)); }, 0);
      var off = Math.round(reg * pct / 100 / 100) * 100;
      return { reg: reg, off: off, fin: reg - off, qty: unitsOf(o).length };
    }
    function bumpTotal() {
      return bumps.reduce(function (s, b) {
        var c = $(b, '[data-lv-bump-check]'); if (!c || !c.checked) return s;
        var v = $(b, '[data-lv-bump-var]'); var opt = v && v.tagName === 'SELECT' ? v.options[v.selectedIndex] : v;
        return s + Number((opt && opt.dataset.price) || 0);
      }, 0);
    }
    function render() {
      opts.forEach(function (o) {
        var pr = priceOf(o);
        var t = $(o, '[data-lv-total]'); if (t) t.textContent = yen(pr.fin);
        var u = $(o, '[data-lv-unit]'); if (u) u.textContent = yen(pr.fin / pr.qty);
        var sa = $(o, '[data-lv-save-amt]'); if (sa) sa.textContent = yen(pr.off);
        var w = $(o, '[data-lv-was]'); if (w && Number(o.dataset.pct) > 0) w.textContent = yen(pr.reg);
      });
      var o = selected(); if (!o) return;
      if (btnTotal) btnTotal.textContent = '｜' + yen(priceOf(o).fin + bumpTotal());
    }
    function choose(o) {
      opts.forEach(function (x) { var on = x === o; x.classList.toggle('is-selected', on); var r = $(x, 'input[type=radio]'); if (r) r.checked = on; });
      render();
    }
    opts.forEach(function (o) {
      o.addEventListener('click', function (e) { if (e.target.closest('select,label[for^="lv-v-"]')) return; choose(o); });
      var r = $(o, 'input[type=radio]'); if (r) r.addEventListener('change', function () { if (r.checked) choose(o); });
      $$(o, '[data-lv-var]').forEach(function (s) { s.addEventListener('change', render); });
    });
    bumps.forEach(function (b) {
      var c = $(b, '[data-lv-bump-check]');
      b.addEventListener('click', function (e) { if (e.target === c || e.target.closest('select,label')) return; c.checked = !c.checked; c.dispatchEvent(new Event('change')); });
      c.addEventListener('change', function () { b.classList.toggle('is-on', c.checked); render(); });
      var s = $(b, 'select[data-lv-bump-var]'); if (s) s.addEventListener('change', render);
    });

    function buildItems() {
      var o = selected(); var counts = {}; var order = [];
      unitsOf(o).forEach(function (id) { if (!counts[id]) { counts[id] = 0; order.push(id); } counts[id]++; });
      var items = order.map(function (id) { return { id: id, quantity: counts[id] }; });
      bumps.forEach(function (b) {
        var c = $(b, '[data-lv-bump-check]'); if (!c || !c.checked) return;
        var v = $(b, '[data-lv-bump-var]'); if (v && v.value) items.push({ id: Number(v.value), quantity: 1 });
      });
      return items;
    }
    if (btn) btn.addEventListener('click', function () {
      if (btn.disabled) return;
      err.textContent = ''; btn.disabled = true; btn.classList.add('is-loading');
      var body = { items: buildItems(), sections: sectionIds(), sections_url: window.location.pathname };
      fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
        .then(function (j) { notify(j); openCart(j); })
        .catch(function (e) { err.textContent = (e && (e.description || e.message)) || root.dataset.err || ''; })
        .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
    });

    /* Barra fixa */
    var sticky = $(root, '[data-lv-sticky]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      var past = false;
      new IntersectionObserver(function (en) {
        en.forEach(function (x) { past = !x.isIntersecting && x.boundingClientRect.top < 0; sticky.classList.toggle('is-on', past); sticky.setAttribute('aria-hidden', past ? 'false' : 'true'); var b = $(sticky, '[data-lv-sticky-btn]'); if (b) b.tabIndex = past ? 0 : -1; });
      }, { threshold: 0 }).observe(btn);
      $(sticky, '[data-lv-sticky-btn]').addEventListener('click', function () {
        var target = $(root, '#lv-offer') || btn;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* Kit vindo das LPs (?bundle=2) */
    try { var bq = new URLSearchParams(window.location.search).get('bundle'); if (bq) { var bo = opts.filter(function (x) { return x.dataset.qty === bq; })[0]; if (bo) choose(bo); } } catch (e) {}
    initGallery(root); initDelivery(root); render();
  }

  /* ---------- Botões "ir para a oferta" das outras seções ---------- */
  function initScrollers() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-lv-to-offer]'); if (!a) return;
      var t = document.getElementById('lv-offer'); if (!t) return;
      e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------- Ondas sonoras (seção do mecanismo) ---------- */
  function initRipple() {
    var els = $$(document, '.lv-ft--ripple'); if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { threshold: 0.45 });
    els.forEach(function (el) { io.observe(el); });
  }

  function boot() { $$(document, '[data-lv-bb]').forEach(initBuybox); initScrollers(); initRipple(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    $$(e.target, '[data-lv-bb]').forEach(initBuybox);
    $$(e.target, '.lv-ft--ripple').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
